import UserAccuountTrigger from './UserAccuountTrigger'

export default UserAccuountTrigger
